import {defineMessages, type IntlShape} from 'react-intl'

export const INIT_FORM_SIGNATURE = {
  name: '',
  descripcion: '',
  formContent: '',
  emailContent: '',
  smsContent: '',
  status: 'ACTIVE',
  language: 'es',
  id: '',
}

export const tabOrder = [
  'form-settings',
  'form-notifications',
  'form-content',
  // 'form-disclaimers',
] as const

export const clientVarsByLead = {
  name: 'clientsByLead',
  label: 'Client (Lead)',
  icon: 'bi bi-person-lines-fill',
  options: [
    {key: 'client_name', label: 'Client Name'},
    {key: 'client_email', label: 'Client Email'},
    {key: 'client_phone', label: 'Client Phone'},
    {key: 'client_address', label: 'Client Address'},
    {key: 'client_city', label: 'Client City'},
    {key: 'client_state', label: 'Client State'},
    {key: 'client_zip', label: 'Client Zip'},
  ],
}

export const clientVarsByPolicy = {
  name: 'clientsByPolicy',
  label: 'Client (Policy)',
  icon: 'bi bi-person-vcard',
  options: [
    {key: 'client_address', label: 'Client Address'},
    {key: 'client_address_2', label: 'Client Address 2'},
    {key: 'client_city', label: 'Client City'},
    {key: 'client_state', label: 'Client State'},
    {key: 'client_zip', label: 'Client Zip'},
    {key: 'client_first_name', label: 'Client First Name'},
    {key: 'client_middle_name', label: 'Client Middle Name'},
    {key: 'client_last_name', label: 'Client Last Name'},
    {key: 'client_first_name_upper', label: 'Client First Name Upper'},
    {key: 'client_middle_name_upper', label: 'Client Middle Name Upper'},
    {key: 'client_last_name_upper', label: 'Client Last Name Upper'},
    {key: 'client_email', label: 'Client Email'},
    {key: 'client_phone', label: 'Client Phone'},
    {key: 'client_dob', label: 'Client Dob'},
    {key: 'client_gender', label: 'Client Gender'},
    {key: 'client_marital_status', label: 'Client Marital Status'},
    {key: 'client_ssn', label: 'Client SSN'},
    {key: 'client_preferred_language', label: 'Client Preferred Language'},
    {key: 'client_income', label: 'Client Income'},
    {key: 'client_source_of_income', label: 'Client Source of Income'},
  ],
}

export const infoPolicyVars = {
  name: 'infoPolicy',
  label: 'Policy',
  icon: 'bi bi-file-earmark-text',
  options: [
    {key: 'policy_effective_date', label: 'Policy Effective Date'},
    {key: 'policy_total_cost', label: 'Policy Total Cost'},
    {key: 'policy_premium', label: 'Policy Premium'},
    {key: 'client_name', label: 'Client Name'},
  ],
}

export const infoAgenteVars = {
  name: 'infoAgente',
  label: 'Agente',
  icon: 'bi bi-person-badge',
  options: [
    {key: 'agent_name', label: 'Agent Name'},
    {key: 'agent_email', label: 'Agent Email'},
    {key: 'agent_phone', label: 'Agent Phone'},
    {key: 'agent_npn', label: 'Agent Npn'},
  ],
}

// i18n de los pickers de variables del RichTextEditor. No se mutan los consts crudos
// de arriba (§17.10); se reconstruyen en render con labels traducidos vía este helper.
const varGroupMessages = defineMessages({
  clientsByLead: {id: 'documents.signatureForms.var.group.clientLead', defaultMessage: 'Client (lead)'},
  clientsByPolicy: {id: 'documents.signatureForms.var.group.clientPolicy', defaultMessage: 'Client (policy)'},
  infoPolicy: {id: 'documents.signatureForms.var.group.policy', defaultMessage: 'Policy'},
  infoAgente: {id: 'common.field.agent', defaultMessage: 'Agent'},
})

const varFieldMessages = defineMessages({
  client_name: {id: 'documents.signatureForms.var.field.clientName', defaultMessage: 'Client name'},
  client_email: {id: 'documents.signatureForms.var.field.clientEmail', defaultMessage: 'Client email'},
  client_phone: {id: 'documents.signatureForms.var.field.clientPhone', defaultMessage: 'Client phone'},
  client_address: {id: 'documents.signatureForms.var.field.clientAddress', defaultMessage: 'Client address'},
  client_address_2: {id: 'documents.signatureForms.var.field.clientAddress2', defaultMessage: 'Client address 2'},
  client_city: {id: 'documents.signatureForms.var.field.clientCity', defaultMessage: 'Client city'},
  client_state: {id: 'documents.signatureForms.var.field.clientState', defaultMessage: 'Client state'},
  client_zip: {id: 'documents.signatureForms.var.field.clientZip', defaultMessage: 'Client zip'},
  client_first_name: {id: 'documents.signatureForms.var.field.clientFirstName', defaultMessage: 'Client first name'},
  client_middle_name: {id: 'documents.signatureForms.var.field.clientMiddleName', defaultMessage: 'Client middle name'},
  client_last_name: {id: 'documents.signatureForms.var.field.clientLastName', defaultMessage: 'Client last name'},
  client_first_name_upper: {id: 'documents.signatureForms.var.field.clientFirstNameUpper', defaultMessage: 'Client first name upper'},
  client_middle_name_upper: {id: 'documents.signatureForms.var.field.clientMiddleNameUpper', defaultMessage: 'Client middle name upper'},
  client_last_name_upper: {id: 'documents.signatureForms.var.field.clientLastNameUpper', defaultMessage: 'Client last name upper'},
  client_dob: {id: 'documents.signatureForms.var.field.clientDob', defaultMessage: 'Client DOB'},
  client_gender: {id: 'documents.signatureForms.var.field.clientGender', defaultMessage: 'Client gender'},
  client_marital_status: {id: 'documents.signatureForms.var.field.clientMaritalStatus', defaultMessage: 'Client marital status'},
  client_ssn: {id: 'documents.signatureForms.var.field.clientSsn', defaultMessage: 'Client SSN'},
  client_preferred_language: {id: 'documents.signatureForms.var.field.clientPreferredLanguage', defaultMessage: 'Client preferred language'},
  client_income: {id: 'documents.signatureForms.var.field.clientIncome', defaultMessage: 'Client income'},
  client_source_of_income: {id: 'documents.signatureForms.var.field.clientSourceOfIncome', defaultMessage: 'Client source of income'},
  policy_effective_date: {id: 'documents.signatureForms.var.field.policyEffectiveDate', defaultMessage: 'Policy effective date'},
  policy_total_cost: {id: 'documents.signatureForms.var.field.policyTotalCost', defaultMessage: 'Policy total cost'},
  policy_premium: {id: 'documents.signatureForms.var.field.policyPremium', defaultMessage: 'Policy premium'},
  agent_name: {id: 'documents.signatureForms.var.field.agentName', defaultMessage: 'Agent name'},
  agent_email: {id: 'documents.signatureForms.var.field.agentEmail', defaultMessage: 'Agent email'},
  agent_phone: {id: 'documents.signatureForms.var.field.agentPhone', defaultMessage: 'Agent phone'},
  agent_npn: {id: 'documents.signatureForms.var.field.agentNpn', defaultMessage: 'Agent NPN'},
})

type PickerConst = {name: string; label: string; icon?: string; options: {key: string; label: string}[]}

const localizePicker = (intl: IntlShape, picker: PickerConst): PickerConst => {
  const groupMsg = varGroupMessages[picker.name as keyof typeof varGroupMessages]
  return {
    ...picker,
    label: groupMsg ? intl.formatMessage(groupMsg) : picker.label,
    options: picker.options.map((opt) => {
      const fieldMsg = varFieldMessages[opt.key as keyof typeof varFieldMessages]
      return {...opt, label: fieldMsg ? intl.formatMessage(fieldMsg) : opt.label}
    }),
  }
}

export const buildLocalizedPickers = (intl: IntlShape) => [
  localizePicker(intl, clientVarsByLead),
  localizePicker(intl, clientVarsByPolicy),
  localizePicker(intl, infoPolicyVars),
  localizePicker(intl, infoAgenteVars),
]
